import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { IntentRanking } from '@/model/Analytics';
import QuestionIcon from '@/assets/svgs/question_mark.svg';


interface IntentCardBodyProps {
    ranking: IntentRanking;
    total: number;
}

const IntentCardBody: React.FC<IntentCardBodyProps> = ({ ranking, total }) => {
    const intl = useIntl();

    const noIntentCount = total - ranking.total;

    if (total === 0) {
        return (
            <div className="size-full flex items-center justify-center text-[14px] font-[400] leading-none text-black-400">
                {intl.formatMessage({ id: "b0013" })}
            </div>
        );
    }
    return (
        <ol className="size-full grid grid-cols-[40px_1fr_max-content] gap-x-4 gap-y-4">
            <div className="px-4 py-1 h-[260px] col-span-3 grid grid-cols-subgrid grid-rows-[repeat(5,minmax(0,1fr))] rounded-[6px] bg-chat42-5">
                {ranking.list.slice(0, 5).map(({ _id: name, count }, index) => (
                    <li key={index}
                        aria-label={`${index + 1}. ${name}`}
                        className={classNames(
                            "col-span-3 grid grid-cols-subgrid h-full items-center justify-between border-b border-black-200",
                            index === 4 && "border-b-0"
                        )}
                    >
                        <div aria-hidden="true"
                             className="ml-auto size-5.5 flex items-center justify-center rounded-[4px] bg-chat42-20 text-black-500 text-[12px] font-[600]"
                        >
                            {index + 1}
                        </div>
                        <div className="text-[14px] font-[500] text-black-500">
                            {name}
                        </div>
                        <div className="text-[12x] font-[400] text-black-500 tabular-nums">
                            {`${count.toLocaleString()} (${(total ? (count / total * 100).toFixed(0) : 0)}%)`}
                        </div>
                    </li>
                ))}
            </div>

            <li className="px-4 col-span-3 w-full grid grid-cols-subgrid items-center"
                aria-label={intl.formatMessage({ id: "i01012" })}
            >
                <img src={QuestionIcon} alt=""
                     className="ml-auto size-4.5"
                />
                <div className="text-[14px] font-[500] text-black-500">
                    {intl.formatMessage({ id: "i01012" })}
                </div>

                <div className="text-[12x] font-[400] text-black-500 tabular-nums">
                    {`${noIntentCount.toLocaleString()} (${(total ? (noIntentCount / total * 100).toFixed(0) : 0)}%)`}
                </div>
            </li>
        </ol>
    );
};

export default IntentCardBody;
